import React from 'react';

type Props = React.SVGAttributes<SVGElement>;

function Icon(props: Props) {
  return (
    <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M2.27595 19.3333C1.56236 17.7001 1.1665 15.8962 1.1665 14C1.1665 6.63616 7.13604 0.666626 14.4998 0.666626C21.8636 0.666626 27.8332 6.63616 27.8332 14C27.8332 21.3638 21.8636 27.3333 14.4998 27.3333C11.4976 27.3333 8.72719 26.3411 6.49854 24.6666M10.4998 10.6666L18.4998 18.6666M18.4998 10.6666L10.4998 18.6666"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Icon;
